export default __webpack_public_path__ + "static/media/9.7f47df50.jpg";